// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__66mo2"};